<template>
  <TabbedPortletOpportunity>
    <TabbedPortletHead>
      <li class="nav-item">
        <a
          href=""
          class="nav-link"
          :class="{ 'active': selectedTab === tabs.OPPORTUNITY_DETAILS_TAB }"
          @click.prevent="selectTab(tabs.OPPORTUNITY_DETAILS_TAB)">&nbsp;&nbsp;Opportunity Details&nbsp;&nbsp;</a>
      </li>
      <li class="nav-item">
        <a
          href=""
          class="nav-link"
          :class="{ 'active': selectedTab === tabs.CLIENT_INFORMATION_TAB }"
          @click.prevent="selectTab(tabs.CLIENT_INFORMATION_TAB)">&nbsp;&nbsp;Client Information&nbsp;&nbsp;</a>
      </li>
      <li class="nav-item">
        <a
          href=""
          class="nav-link"
          :class="{ 'active': selectedTab === tabs.QUOTE_REQUEST_FORM_TAB }"
          @click.prevent="selectTab(tabs.QUOTE_REQUEST_FORM_TAB)">&nbsp;&nbsp;Quote request form&nbsp;&nbsp;</a>
      </li>
    </TabbedPortletHead>

    <TabbedPortletBody>
      <div class="tab-content">
        <TabbedPortletBodyTab :show="selectedTab === tabs.OPPORTUNITY_DETAILS_TAB">
          <OpportunityDetailsTab
            v-if="opportunityDetails"
            :validationGroupName="validationGroupName" />
        </TabbedPortletBodyTab>

        <TabbedPortletBodyTab :show="selectedTab === tabs.CLIENT_INFORMATION_TAB" >
          <ClientInformationTab
            v-if="clientDetails"
            :validationGroupName="validationGroupName" />
        </TabbedPortletBodyTab>

        <TabbedPortletBodyTab :show="selectedTab === tabs.QUOTE_REQUEST_FORM_TAB">
          <QuoteRequestFormTab
            v-if="opportunityDetails"
            :validationGroupName="validationGroupName" />
        </TabbedPortletBodyTab>
      </div>
    </TabbedPortletBody>

    <TabbedPortletFoot>
      <template v-slot:rightButtons>
        <BaseButton
          class="btn-outline-hover-info btn-elevate btn-wide text-info"
          @click="nextStep()"
          :disabled="currentStep >= maxSteps"
          v-if="!(currentStep >= maxSteps)">
          <div class="d-flex align-content-center">
            <span class="mr-2 text-footer-button">Next</span>
            <font-awesome-icon :icon="['fas', 'chevron-right']" />
          </div>
        </BaseButton>
      </template>
    </TabbedPortletFoot>
  </TabbedPortletOpportunity>
</template>

<script>
import { mapGetters } from 'vuex'
import WizardConfig from '@/components/_shared/wizard/config'

import TabbedPortletOpportunity from '@/components/_shared/tabbed-portlet-opportunity/TabbedPortletOpportunity.vue'
import TabbedPortletHead from '@/components/_shared/tabbed-portlet/TabbedPortletHead.vue'
import TabbedPortletBody from '@/components/_shared/tabbed-portlet/TabbedPortletBody.vue'
import TabbedPortletBodyTab from '@/components/_shared/tabbed-portlet/TabbedPortletBodyTab.vue'
import TabbedPortletFoot from '@/components/_shared/tabbed-portlet/TabbedPortletFoot.vue'

import OpportunityDetailsTab from '@/components/opportunity-details/OpportunityDetailsTab.vue'
import ClientInformationTab from '@/components/opportunity-details/ClientInformationTab.vue'
import QuoteRequestFormTab from '@/components/opportunity-details/QuoteRequestFormTab.vue'

export default {
  name: 'OpportunityDetails',
  inject: ['$v'],
  components: {
    TabbedPortletOpportunity,
    TabbedPortletHead,
    TabbedPortletBody,
    TabbedPortletBodyTab,
    TabbedPortletFoot,
    OpportunityDetailsTab,
    ClientInformationTab,
    QuoteRequestFormTab
  },
  data () {
    const OPPORTUNITY_DETAILS_TAB = 'opportunity-details-tab'
    const CLIENT_INFORMATION_TAB = 'client-information-tab'
    const QUOTE_REQUEST_FORM_TAB = 'tab-quote-request-form-tab'

    const VALIDATION_GROUP_NAME = 'newOpportunity'

    return {
      validationGroupName: VALIDATION_GROUP_NAME,
      currentStep: 1,
      minSteps: WizardConfig.minSteps,
      maxSteps: WizardConfig.maxSteps,
      selectedTab: OPPORTUNITY_DETAILS_TAB,
      tabs: {
        OPPORTUNITY_DETAILS_TAB,
        CLIENT_INFORMATION_TAB,
        QUOTE_REQUEST_FORM_TAB
      }
    }
  },
  computed: {
    ...mapGetters({
      'opportunityDetails': 'opportunity/opportunityDetails',
      'clientDetails': 'opportunity/clientDetails'
    })
  },
  methods: {
    selectTab (tabName) {
      this.selectedTab = tabName
    },
    _goToRoute (stepNumber) {
      const stepSelected = WizardConfig.stepValues.filter(s => s.number === stepNumber).shift()
      const params = {
        privateId: this.$route.params.privateId,
        step: stepNumber
      }
      this.$router.push({ name: stepSelected.url, params })
    },
    validTab () {
      if (this.$v.newOpportunity.opportunityDetailsTab.$error) {
        return this.selectTab(this.tabs.OPPORTUNITY_DETAILS_TAB)
      }
    },
    nextStep () {
      this.save(false)
      this.validTab()
      if (!this.$v.$invalid) {
        this.currentStep = this.currentStep + 1
        this._goToRoute(this.currentStep)
        this.$v.$reset()
      }
    },
    save (showNotification = true) {
      // "touching" all fields to turn them "dirty"
      this.$v.$touch()
      this.validTab()
      // submit form only when all fields are valid
      if (!this.$v.$invalid) {
        const newOpportunityData = this.$v.newOpportunity.$model
        const payload = Object.assign({}, newOpportunityData)
        const uuid = this.$route.params.privateId
        this.$store.commit('opportunity/SAVE_NEWOPPORTUNITY', { uuid, payload })
        if (showNotification) {
          this.$notification.success('Changes saved successfully!')
        }
      }
    }
  }
}
</script>

<style>
.nav-link.active {
  font-weight: 600!important;
}
</style>
